import { Button, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { convertFileList } from './utils/convertFile';
import { formatBytes } from '../../utils/formatBytes';
import { FilePreviews } from './components/FilePreviews';
import { useResponsiveButtonSize } from '../../utils/hooks';
import { pluralize } from '../../utils/pluralize';
import * as styles from './FileUploader.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FileUploader = function FileUploader(_ref) {
  var id = _ref.id,
    name = _ref.name,
    text = _ref.text,
    files = _ref.files,
    status = _ref.status,
    acceptRaw = _ref.accept,
    _ref$filesCountLimit = _ref.filesCountLimit,
    filesCountLimit = _ref$filesCountLimit === void 0 ? Infinity : _ref$filesCountLimit,
    _ref$fileSizeLimit = _ref.fileSizeLimit,
    fileSizeLimit = _ref$fileSizeLimit === void 0 ? Infinity : _ref$fileSizeLimit,
    disabledRaw = _ref.disabled,
    onAdd = _ref.onAdd,
    onRemove = _ref.onRemove,
    onError = _ref.onError,
    onClick = _ref.onClick,
    onRetry = _ref.onRetry,
    onBlur = _ref.onBlur;
  var size = useResponsiveButtonSize();
  var deviceType = useDeviceType();
  var isPhone = deviceType === 'phone';
  var inputRef = React.useRef(null);
  var defaultAccept = 'image/*';
  var accept = acceptRaw ? acceptRaw.map(function (ext) {
    return ".".concat(ext);
  }).join(', ') || defaultAccept : defaultAccept;
  var disabled = disabledRaw || files.length >= filesCountLimit;
  var handleClick = React.useCallback(function () {
    if (onClick) {
      onClick();
    }
    if (!inputRef.current) {
      return;
    }
    inputRef.current.click();
  }, [onClick]);
  var handleChange = React.useCallback(function () {
    if (!inputRef.current || !inputRef.current.files) {
      return;
    }

    // сначала фильтруем все файлы по размеру, отсеиваем те что превышают fileSizeLimit,
    // лишь потом фильтруем по filesCountLimit
    var inputFiles = Array.from(inputRef.current.files);
    var inputFilesFilteredBySize = inputFiles.filter(function (file) {
      return file.size <= fileSizeLimit;
    });
    var nextFiles = convertFileList(inputFilesFilteredBySize.slice(0, filesCountLimit - files.length));
    if (inputFilesFilteredBySize.length < inputFiles.length) {
      onError("\u041D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0444\u0430\u0439\u043B\u044B, \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0449\u0438\u0435 \u0440\u0430\u0437\u043C\u0435\u0440 ".concat(formatBytes(fileSizeLimit), ", \u043D\u0435 \u0431\u044B\u043B\u0438 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u044B"));
    } else if (nextFiles.length < inputFilesFilteredBySize.length) {
      onError("\u041C\u043E\u0436\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 ".concat(filesCountLimit, " ").concat(pluralize(filesCountLimit, 'файла', 'файлов', 'файлов')));
    }
    onAdd(nextFiles);
    inputRef.current.value = '';
  }, [files, onAdd, onError, filesCountLimit, fileSizeLimit]);

  /**
   * TODO починить onRemove, он не провоцирует смену status у request-form.
   * Как результат - не отображается ошибка для этого поля.
   * Как воспроизвести:
   * 1. Сделать поле file required, чтобы оно было обязательным для отправки формы.
   * 2. Добавить 1 файл, загрузка которого зафейлится.
   * 3. Нажать кнопку "Отправить", форма переведётся в состояние "questionSubmitted".
   * 4. Удалить этот самый зафейленый файл. Форма всё так же остается в состоянии "questionSubmitted",
   *    хотя мы это поле потрогали.
   * 5. Снова нажать кнопку "Отправить". Ошибка под полей file не отображается,
   *    при нажатии кнопки "Отправить" ничего не происходит, ведь yup валидатор фейлится.
   */
  var handleRemove = React.useCallback(function (value) {
    if (onClick) {
      onClick();
    }
    onRemove(value);
  }, [onClick, onRemove]);
  var handleRetry = React.useCallback(function (value) {
    if (onClick) {
      onClick();
    }
    onRetry(value);
  }, [onClick, onRetry]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx(Button, {
      type: "button",
      fullWidth: isPhone,
      size: size,
      disabled: disabled,
      onClick: handleClick,
      onBlur: onBlur,
      children: text || 'Загрузить файл'
    }), /*#__PURE__*/_jsx("input", {
      id: id,
      ref: inputRef,
      className: styles['input'],
      name: name,
      type: "file",
      accept: accept,
      disabled: disabled,
      onChange: handleChange,
      multiple: true
    }), files.length > 0 && /*#__PURE__*/_jsx(FilePreviews, {
      files: files,
      status: status,
      onRemove: handleRemove,
      onRetry: handleRetry
    })]
  });
};
FileUploader.displayName = 'FileUploader';